import React from 'react';
import './SkeletonText.css';

/**
 * Inline skeleton placeholder shown while async content loads.
 */
export default function SkeletonText({ width = '100%', height = '1em', className = '' }) {
    return (
        <span
            className={`skeleton-text ${className}`.trim()}
            style={{ width, height }}
            aria-hidden="true"
        />
    );
}
